module.exports = __webpack_public_path__ + "img/csr_111123_I.a7ceba37.jpg";